import { trackEvent } from 'helpers/analytics';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { activeNetworkSelector } from 'redux/selectors';
import { useExportContactsToCsvMutation, useGetSharedListsQuery } from 'services/contacts';
import { contactDataSelection } from 'services/contacts/selectedRows';
import toast from 'react-hot-toast';

export const useExportContactsCsv = ({ selectedRows, queryParams, contactIds, meta, type }) => {
  const [exportContactsToCsv, { isLoading }] = useExportContactsToCsvMutation();
  const { data: { sharedLists = [] } = {} } = useGetSharedListsQuery(
    {},
    {
      skip: type === 'public',
    },
  );
  const activeNetwork = useSelector(activeNetworkSelector);
  const totalSelectedRowsCount = selectedRows.length;
  const activeList = useMemo(
    () => sharedLists.find((item) => item.id === parseInt(queryParams.listId, 10)),
    [queryParams, sharedLists],
  );

  const onClickExportContacts = async () => {
    if (!isLoading) {
      const { selectedDataRows, excludedDataRows } = contactDataSelection(selectedRows, contactIds, meta.queryTotal);

      trackEvent('lists:export_csv', {
        collection_id: activeNetwork.id,
        list_slug: activeList?.slug,
        total_selected_rows: totalSelectedRowsCount,
        object_type: 'people',
      });

      try {
        await exportContactsToCsv({
          filters: queryParams.filters,
          contactIds: selectedDataRows,
          excludedContactIds: excludedDataRows,
          listId: queryParams.listId,
        });

        toast('Export in progress — we’ll email it to you in a few minutes.', {
          icon: 'success',
          id: 'export-csv-success',
        });
      } catch {
        toast('There was an unexpected error, try again or send us a chat.', {
          icon: 'danger',
          id: 'export-csv-error',
        });
      }
    }
  };

  return {
    onClickExportContacts,
    isLoading,
  };
};
